export default function defaultRedirectUrl(accountType) {
  const options = {
    brand: '/creators',
    influencer: '/opportunities',
    default: '/opportunities',
  };
  return options[accountType] ?? options.default;
}
